




















































import { ref, createComponent, Ref, onMounted, reactive, computed } from '@vue/composition-api'
import axios from 'axios'
import { getTaskListUnzipCompress, UnzipComporessListItem, handlePagination } from '@/service/transferList'
import { formatFileSize, getFileIcon } from '@/helpers/common'
import moment from 'moment'

export default createComponent({
    setup(props, setupContext) {
        const tableData = ref<UnzipComporessListItem[]>([])
        const { handleCurrentChange, pageSize, currentPageNum, currentList, updateCurrentList } = handlePagination(
            tableData
        )
        const getTableData = async () => {
            const res = await getTaskListUnzipCompress()
            if (res.code === 0) {
                tableData.value = res.data
            } else {
                tableData.value = []
            }
            updateCurrentList()
        }
        const handleSearch = async () => {
            getTableData()
        }
        onMounted(async () => {
            currentPageNum.value = 1
            handleSearch()
        })
        return {
            moment,
            formatFileSize,
            getFileIcon,
            tableData,
            handleSearch,
            pageSize,
            handleCurrentChange,
            currentList,
        }
    },
})
